<template>
  <div class="price-range-list card p-2">
    <div class="header-section d-flex justify-content-between align-items-center">
      <h3>{{ priceRanges[0] && priceRanges[0].nome_vacina }}</h3>
      <b-badge variant="light-primary" pill>2026</b-badge>
    </div>
    
    <div
      v-for="(item, index) in priceRanges"
      :key="index"
      class="price-card align-items-center"
    >
      <div class="left-content d-flex align-items-center">
        <div class="vertical-bar text-warning">|</div>
        <div class="range-title">{{ formatRangeDescription(item) }}</div>
      </div>

      <div class="right-content text-right">
        <div class="label">Valor por Dose</div>
        <div class="text-center">
          <strong class="text-white">
            R${{ formatCurrencyInput(item.valor_dose) }}
          </strong>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
  components: {
    BBadge
  },

  name: 'PriceRangeList',
  props: {
      idVaccine: {
          required: true,
          type: Number|null
      }
  },

  data() {
    return {
      priceRanges: []
    }
  },

  mounted() {
    if (this.idVaccine) {
      this.fetchPriceRanges()
    }
  },

  methods: {
    async fetchPriceRanges() {
      try {
        const response = await this.$http.get(this.$api.campanhaFaixaPreco(), {
          params: { id_vacina: this.idVaccine }
        })

        this.priceRanges = response.data
      } catch (error) {
        console.error('Erro ao buscar faixas de preço:', error)
      }
    },
    formatCurrencyInput(value) {
      if (!value) return ''

      let num = value.toString().replace(/\D/g, '')
      if (!num) return ''

      num = (parseInt(num) / 100).toFixed(2)

      const [integerPart, decimalPart] = num.split('.')
      const formattedInteger = parseInt(integerPart).toLocaleString('pt-BR')
      return `${formattedInteger},${decimalPart}`
    },
    formatRangeDescription(item) {
      const { qtd_minima, qtd_maxima } = item
      
      if (qtd_maxima === null) {
        return 'Acima de 10.000 doses e Região Sul'
      }
      
      return `De ${qtd_minima.toLocaleString('pt-BR')} até ${qtd_maxima.toLocaleString('pt-BR')} doses`
    },
  },

  watch: {
    idVaccine(newId) {
      if (newId) {
        this.fetchPriceRanges()
      }
    }
  }
}
</script>

<style scoped>
.price-range-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.price-card {
  background: linear-gradient(90deg, #1e73be, #1361a5);
  padding: 15px;
  padding-left: 20px;
  border-radius: 6px;
  color: #fff;
  display: flex !important;
  justify-content: space-between !important;
}

.vertical-bar {
  font-size: 22px;
  font-weight: bold;
  margin-right: 8px;
  color: #fff;
}

.header-section .vaccine-name {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.header-section .year-pill {
  background-color: #007bff;
  color: white;
}

.range-title {
  font-size: 18px;
  font-weight: 600;
}

.label {
  font-size: 13px;
  opacity: 0.85;
  margin-bottom: 4px;
}

.price-input {
  max-width: 130px;
  font-weight: bold;
  text-align: right;
}

.year-pill {
  font-size: 12px;
  font-weight: 600;
}
</style>
